export default "__VITE_ASSET__b7f67cc4__"